import React from "react";

import { Main } from "./component/Main.tsx"

export function App(props) {
  return (
    <Main />
  );
}

export default App;
